/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type parent_ParentDunningNoticeDetailDTO = {
    /**
     * BodyHTML is the HTML body of the email; omitted when the email had none.
     */
    bodyHtml?: string;
    /**
     * BodyText is the plain-text body of the email.
     */
    bodyText: string;
    /**
     * ID is the letter id.
     */
    id: string;
    /**
     * InvoiceIDs are the invoices the letter concerns; empty when none can be named.
     */
    invoiceIds: Array<string>;
    /**
     * SentAt is when the letter was sent.
     */
    sentAt: string;
    /**
     * Stage is the dunning stage of the letter.
     */
    stage: parent_ParentDunningNoticeDetailDTO.stage;
    /**
     * Subject is the email subject as sent.
     */
    subject: string;
};
export namespace parent_ParentDunningNoticeDetailDTO {
    /**
     * Stage is the dunning stage of the letter.
     */
    export enum stage {
        REMINDER_1 = 'reminder_1',
        REMINDER_2 = 'reminder_2',
        REMINDER_3 = 'reminder_3',
        FINAL_NOTICE = 'final_notice',
        FINAL_REPEAT = 'final_repeat',
    }
}

